import PropTypes from "prop-types";
import clsx from "clsx";
import {
    createMarkup,
    formatExternalUrl,
    stripHtml,
} from "../../helpers/utils";
import { Typography } from "@mui/material";

const TeamMemberMainSingle = ({ data, spaceBottomClass }) => {
    return (
        <div className={clsx("team-wrapper", spaceBottomClass)}>
            <div className="team-img">
                <img
                    src={formatExternalUrl(data.image_url)}
                    alt=""
                    className="img-fluid"
                />
                {/* <div className="team-action">
                    <a
                        className="facebook"
                        href={data.fbLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="fa fa-facebook" />
                    </a>
                    <a
                        className="twitter"
                        href={data.twitterLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="fa fa-twitter" />
                    </a>
                    <a
                        className="instagram"
                        href={data.instagramLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <i className="fa fa-instagram" />
                    </a>
                </div> */}
            </div>
            <div className="team-content text-center">
                <h4>{data.title}</h4>
                <span
                    dangerouslySetInnerHTML={createMarkup(data.description, [
                        { tag: "p", style: { marginBottom: 0 } },
                    ])}
                ></span>
            </div>
        </div>
    );
};

TeamMemberMainSingle.propTypes = {
    data: PropTypes.shape({}),
    spaceBottomClass: PropTypes.string,
};

export default TeamMemberMainSingle;
